module.exports = __webpack_public_path__ + "img/20191212172507360截图20191212170120351.b9ceb5f4.jpg";